import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Bot, KeyRound } from 'lucide-react';

import { PageBody, PageHead } from '../components/aa';
import { PeopleUsagePanel } from '../components/settings/PeopleUsagePanel';
import { ApiUsagePanel } from '../components/settings/ApiUsagePanel';

export const AI_USAGE_TAB = 'ai';
const API_USAGE_TAB = 'api';

const TABS = [
  { id: AI_USAGE_TAB, label: 'AI usage', icon: Bot },
  { id: API_USAGE_TAB, label: 'API usage', icon: KeyRound },
];

const UsagePage: React.FC = () => {
  const [params, setParams] = useSearchParams();
  let shown = AI_USAGE_TAB;
  if (params.get('tab') === API_USAGE_TAB) shown = API_USAGE_TAB;

  const pick = (id: string) => setParams({ tab: id }, { replace: true });

  let panel = <PeopleUsagePanel />;
  if (shown === API_USAGE_TAB) panel = <ApiUsagePanel />;

  return (
    <PageBody>
      <PageHead
        align="center"
        title="Usage"
        sub="What your people and your API keys used, and what it cost."
      />
      <div className="space-y-5">
        <div className="border-b border-gray-200">
          <nav className="-mb-px flex items-end gap-1 overflow-x-auto" aria-label="Usage">
            {TABS.map(t => {
              const Icon = t.icon;
              const on = shown === t.id;
              let tone = 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700';
              if (on) tone = 'border-brand-500 text-brand-600';
              return (
                <button
                  key={t.id}
                  type="button"
                  role="tab"
                  aria-selected={on}
                  onClick={() => pick(t.id)}
                  className={`flex items-center gap-2 whitespace-nowrap border-b-2 px-3 py-2.5 text-sm font-medium transition-colors ${tone}`}
                >
                  <Icon size={16} />
                  {t.label}
                </button>
              );
            })}
          </nav>
        </div>
        {panel}
      </div>
    </PageBody>
  );
};

export default UsagePage;
